import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import printerimg from "../../../../assets/print.png";
import { useGetSerialNoByNameQuery,usePostUpdateSerialNoMutation } from "../../../../store/api/serialnoapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import Attachment from "../../../../utils/Attachment";
import { usePageState } from "../../../../Hook/usePageState";
import { useItemcodeserialMutation } from "../../../../store/api/serialnoapi";
import { useCompanyserialMutation } from "../../../../store/api/serialnoapi";
import { useWorkOrderserialMutation } from "../../../../store/api/serialnoapi";
import { isStateChanged } from "../../../../utils/stateComparator";
const PurchaseSerialList = () => {
  const navigate = useNavigate();

  const [itemCodeList, setItemCodeList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [workOrderList, setWorkOrderList] = useState([]);
  const [UpdateSerialNo] = usePostUpdateSerialNoMutation();

  // const [tab, settab] = useState(1);

  const location = useLocation();
  const IdData = location.state?.ItemId;
  console.log(IdData, "IdData")
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const { data: apiData, isLoading } = useGetSerialNoByNameQuery(IdData);
  const [ItemcodeserialApi] = useItemcodeserialMutation();
  const [CompanyserialApi] = useCompanyserialMutation();
  const [WorkOrderserialApi] = useWorkOrderserialMutation();
  const [alldata, setAllData] = useState([])
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    if (apiData && apiData.docs?.length > 0) {
      setAllData(apiData.docs[0]); // take the first object
    }
  }, [apiData]);

  const [fetchdata, setFetchdata] = useState(true)
  const defaultState = {
    tab: 1,
    finalstep: false,
    serialNo: "",
    itemCode: "",
    warrantyExpiryDate: "",
    amcExpiryDate: "",
    company: "",
    workOrder: "",
    parentItemGroup: "",
    unicommerceProductCategoryCode: "",
    isGroup: "",
  };

  const [pageState, setPageState] = usePageState(`Edit Serial Number - ${IdData}`, defaultState);

  console.log(fetchdata, "fetchdata");


const handleSubmit = async () => {
  // Construct payload
  const payload = {
    serial_no: IdData,  
    item_code: pageState.itemCode,
    warranty_expiry_date: pageState.warrantyExpiryDate,
    amc_expiry_date: pageState.amcExpiryDate,
    company: pageState.company,
    work_order: pageState.workOrder,
  };

  console.log("Update Payload:", payload);

  try {
    const response = await UpdateSerialNo(payload);

    if (response.error) {
      // Handle server-side errors
      let errorMessage = "Update failed";

      if (response.error.data && response.error.data._server_messages) {
        try {
          const serverMessages = JSON.parse(response.error.data._server_messages);
          if (Array.isArray(serverMessages) && serverMessages.length > 0) {
            const parsedMessage = JSON.parse(serverMessages[0]);
            errorMessage = parsedMessage.message || errorMessage;
          }
        } catch (e) {
          console.warn("Failed to parse _server_messages", e);
        }
      } else {
        errorMessage =
          response.error.data?.message ||
          response.error.data?.exception ||
          errorMessage;
      }

      setptype("Error");
      setError(errorMessage);
      setShowError(true);
      return;
    }

    // ✅ Success
    setptype("Success");
    setError("Serial No updated successfully!");
    setShowError(true);

    // Navigate back to list after short delay
    setTimeout(() => {
      navigate("/master/serialno/serialno-list");
    }, 1500);

  } catch (err) {
    console.error("Unexpected error:", err);
    setptype("Error");
    setError("Unexpected error occurred while updating.");
    setShowError(true);
  }
};

  useEffect(() => {
    if (alldata && !isStateChanged(pageState, defaultState)) {

      setPageState({
        tab: 1,
        finalstep: false,
        serialNo: alldata.serial_no || "",
        itemCode: alldata.item_code || "",
        warrantyExpiryDate: alldata.warranty_expiry_date || "",
        amcExpiryDate: alldata.amc_expiry_date || "",
        company: alldata.company || "",
        workOrder: alldata.work_order || "",
        parentItemGroup: alldata.parent_item_group || "",
        unicommerceProductCategoryCode: alldata.unicommerce_product_category_code || "",
        isGroup: alldata.is_group || "",
      });
    }
  }, [alldata]);



  console.log(pageState, "initlvalue");

  useEffect(() => {
    if (!isLoading && apiData?.docs?.length > 0) {
      setPageState(pageState);
    }
  }, [apiData]);
  const handleInputChange1 = (f, v) => {
    setPageState({ ...pageState, [f]: v });

  };
  // const { data: apiData, isLoading } = useGetSerialNoByNameQuery(IdData);
  const {
    tab, finalstep, serialNo, itemCode, warrantyExpiryDate, amcExpiryDate,
    company, workOrder
  } = pageState;





  useEffect(() => {
    const fetchData = async () => {
      try {
        const [itemCodeResponse, companyResponse, workOrderResponse] = await Promise.all([
          ItemcodeserialApi(),
          CompanyserialApi(),
          WorkOrderserialApi()
        ]);

        // Store API responses in separate state
        setItemCodeList(itemCodeResponse.data?.data || []);
        setCompanyList(companyResponse.data?.data || []);
        setWorkOrderList(workOrderResponse.data?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [ItemcodeserialApi, CompanyserialApi, WorkOrderserialApi]);



  return (
    <FormLayout
      title="Edit Serial No"
      breadcrumbs={[
        { label: "Serial No" },
        { label: "Serial No List", url: "/master/serialno/serialno-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
         <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}
              iconSize={12}
            >
              Update
            </Button>
            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => setPageState({ tab: 1 })}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <Attachment doctype="Serial No" docname={IdData} />
          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2" style={{ height: '100vh' }}>
                  <Tab1
                    pageState={pageState}
                    handleChange={handleInputChange1}
                    itemCodeList={itemCodeList}
                    isLoading={isLoading}

                  />
                  <Tab2
                    pageState={pageState}
                    handleChange={handleInputChange1}
                    itemCodeList={itemCodeList}
                    isLoading={isLoading}

                  />

                  <Tab3
                    workOrderList={workOrderList}
                    companyList={companyList}
                    pageState={pageState}
                    isLoading={isLoading}
                    handleChange={handleInputChange1}

                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default PurchaseSerialList;
